// extracted by mini-css-extract-plugin
export default {"relocation":"relocation_relocation__jkuL8"};